import {
    Box,
    Card,
    CardContent,
    Chip,
    Divider,
    Stack,
    Typography
} from "@mui/material";
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WorkIcon from '@mui/icons-material/Work';
import { getRelativeTime } from "../../util/date";
import { getImagePath } from "../../util/envFn";
import User from "../../types/User";
import { getNullableString } from "../../util/string";
import UserImage from "../../components/UserImage";
import CustomMDPreview from "../../components/CustomMD/CustomMDPreview";

interface UserCardProps {
    user: User;
    selectedUserId: string;
    onClick: (userId: string) => void;
}

export const UserCard = ({ user, selectedUserId, onClick }: UserCardProps) => (
    <Card
        sx={{
            m: .5,
            position: 'relative',
            "&:hover": { cursor: 'pointer' },
            border: selectedUserId === user._id ? theme => `1px solid ${theme.palette.primary.main}` : "1px solid #00000000",
            boxShadow: selectedUserId === user._id
                ? theme => `0 0 2px 0 ${theme.palette.primary.main}`
                : "none"
        }}
        onClick={() => onClick(user._id)}
    >
        <CardContent>
            <Stack direction="row" alignItems="center" gap={2}>
                <UserImage image={user.image} size={60} name={user.fullName || user.email} />
                <Stack>
                    <Typography variant="h6" component="div">
                        {getNullableString(user.fullName || user.email)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getNullableString(user.email)}
                    </Typography>
                </Stack>
            </Stack>

            <Stack gap={2} overflow="hidden" mb={2} pt={2}>
                {/* <Stack gap={1}>
                    <Stack direction="row" gap={1} alignItems="center">
                        <LocationOnIcon fontSize="inherit" sx={{ color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary">
                            {getNullableString("Not set yet")}
                        </Typography>
                    </Stack>

                    <Stack direction="row" gap={1} alignItems="center">
                        <WorkIcon fontSize="inherit" sx={{ color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary">
                            {getNullableString(user.role)}
                        </Typography>
                    </Stack>
                </Stack> */}

                <Stack gap={0.5}>
                    <Typography variant="subtitle2" fontWeight="light">{getNullableString(user.jobTitle, "Job Title Not set yet")}</Typography>
                    <Typography variant="body2" color="text.secondary">{getNullableString(user.jobDescription, "Job Description Not set yet")}</Typography>
                </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" gap={1}>
                <AccessTimeIcon fontSize="small" />
                <Typography variant="body2" color="text.secondary">
                    {/* {getRelativeTime(user.createdAt)} */}
                </Typography>
            </Stack>
        </CardContent>
    </Card>
);